<tmo-dynamic-modal
  [displayModal]="displayModal"
  [modal]="modal"
  (onHide)="closeEPinConflictModal()"
>
  <ng-container header>
    <div class="modal-logo-close">
      <i class="logo-icon t-icon t-icon-logo"></i>
      <a
        href="javascript:void(0)"
        aria-label="Clickable action"
        class="close-x"
        (click)="closeEPinConflictModal()"
        id="cta-default-212"
      >
        <i class="fa fa-times"></i>
      </a>
    </div>
    <h3>{{ staticContent?.oops }}</h3>
  </ng-container>
  <div>
    <ng-container *ngIf="isByos || epinConflictData?.hasOnlyByos; else notByos">
      <p class="m-b-md" *ngIf="isEpin">{{ staticContent?.epinConflictMessageWithSim }}</p>
      <p class="m-b-md" *ngIf="!isEpin">{{ staticContent?.hardgoodConflictInBYOS }}</p>

      <p *ngIf="isByos">{{ staticContent?.deviceFirstConflictMessage }}</p>

      <p *ngIf="epinConflictData?.hasOnlyByos && isEpin">
        {{ staticContent?.epinFirstConflictMessage }}
      </p>
      <p *ngIf="epinConflictData?.hasOnlyByos && !isEpin">
        {{ staticContent?.optionsAfterHardgoodConflict }}
      </p>
    </ng-container>

    <!-- need sim -->
    <ng-template #notByos>
      <ng-container>
        <p class="m-b-md">{{ staticContent?.cannotPurchaseEpin }}</p>
        <p>{{ staticContent?.likeToPurchaseEpin }}</p>
      </ng-container>
    </ng-template>
    <p class="lead bold m-t-lg">{{ staticContent?.deviceErrorCart }}</p>
    <p *ngFor="let conflictMessage of epinConflictData?.conflictingMessage" class="lead">
      {{ conflictMessage }}
    </p>
    <p class="lead bold m-t-lg">{{ staticContent?.deviceErrorSelection }}</p>
    <p class="lead">
      {{ newSelectionName }} {{ symbolContants?.HYPHEN }} {{ currentSelectionPrice }}
    </p>
  </div>
  <ng-container footer>
    <div class="row">
      <div class="col-12 buttons-container button-spacing">
        <div class="button-box">
          <button class="btn btn-secondary" (click)="addNewSelectionToCart()" id="btn-default-254">
            {{ staticContent?.continueWithNewSelection }}
          </button>
        </div>
        <div class="button-box">
          <button class="btn btn-primary" (click)="goToCurrentCartSelection()" id="btn-default-255">
            {{ staticContent?.goToCurrentCart }}
          </button>
        </div>
      </div>
    </div>
  </ng-container>
</tmo-dynamic-modal>
